import { Token } from '@boltenergy-be/shared'
import { UserTypes } from 'store/auth/types'

export const STORAGE_TYPES = {
  localStorage: 'localStorage',
  sessionStorage: 'sessionStorage'
} as const
export type StorageTypes = (typeof STORAGE_TYPES)[keyof typeof STORAGE_TYPES]

export type AuthTokens = {
  token: Token
  refreshToken: Token
}

export type AuthenticatedUserTypes = {
  [key in UserTypes]: boolean
}
